export default __webpack_public_path__ + "static/Quickinstallation_IN-5905_04-fc6d5548057f7056de8a297fda900750.webp";